import { stopAnimation_for_guests } from '../../../../epersonam/plugins/guestFormUtils';
import errorManager from '@/rollbar.js';
class GuestDataValidation {
  ignoreRoomSet = false;
  ignoreRelatives = false;
  skipBedsValidation = true;

  constructor(
    formIdentifier,
    skipBedsValidation,
    roomModalIdentifier,
    requiredRoomInputIdentifiers,
    relativesModalIdentifier,
    relativesInputIdentifier,
    guestFormIdentifier,
  ) {
    this.formIdentifier = formIdentifier;
    this.roomModalIdentifier = roomModalIdentifier;
    this.requiredRoomInputIdentifiers = requiredRoomInputIdentifiers;
    this.relativesModalIdentifier = relativesModalIdentifier;
    this.relativesInputIdentifier = relativesInputIdentifier;
    this.skipBedsValidation = skipBedsValidation;
    this.guestFormIdentifier = guestFormIdentifier;
    console.log('initializing GuestDataValidation...');
    this.bindGuestRoomModalEvents(this.guestFormIdentifier);
    if (this.relativesModalIdentifier !== undefined) {
      this.bindGuestRelativesModalEvents(this.guestFormIdentifier);
    }
  }

  // # Bootstrap does not handle properly multiple modals on the same page...
  // # Remove additional modal-backdrop overlays that were created opening up the various modals
  fixBootstrapBackdrop() {
    if ($('.modal-backdrop').length > 1) {
      $('.modal-backdrop').not(':last').remove();
    }
  }

  isGuestRoomSet() {
    if (this.ignoreRoomSet) {
      return true;
    }

    var errors = false;
    for (const input_identifier of this.requiredRoomInputIdentifiers) {
      var value = $(input_identifier).val() || $(input_identifier).find(':selected').val();
      if (value === '' || value === undefined || value === null) {
        errors = true;
        break;
      }
    }

    if (errors) {
      $(this.roomModalIdentifier).modal('show');
      return false;
    }

    return true;
  }

  isRelativesSet() {
    if (this.relativesInputIdentifier === undefined || $(this.relativesInputIdentifier).val() === 'true' || this.ignoreRelatives) {
      return true;
    } else {
      $(this.relativesModalIdentifier).modal('show');
      return false;
    }
  }

  // Bind click events on action_buttons inside the GuestRoom modal
  // If user clicks on “correggi”, close the modal and let user change input fields
  // If user clicks on “ignora”, simply proceed with the validation and ignore this warning
  bindGuestRoomModalEvents(guestFormIdentifier) {
    console.log('binding room events...');
    const thisClass = this;
    $(this.roomModalIdentifier)
      .on('shown.bs.modal', function (e) {
        thisClass.fixBootstrapBackdrop();
        const $this_modal = $(this);

        $this_modal.find('button.ignore').on('click', function (ev) {
          $this_modal.modal('hide');
          $(thisClass.requiredRoomInputIdentifiers[0]).focus();
          stopAnimation_for_guests(guestFormIdentifier);
        });

        $this_modal.find('button.proceed').on('click', function (ev) {
          $this_modal.modal('hide');
          thisClass.ignoreRoomSet = true;
          thisClass.submit();
        });
      })
      .on('hide.bs.modal', function (e) {
        $(this).find('button.proceed').unbind();
        $(this).find('button.ignore').unbind();
        stopAnimation_for_guests(guestFormIdentifier);
      });
  }

  // Bind click events on action_buttons inside the GuestRelatives modal
  // If user clicks on “correggi”, change value of $("#insert_relatives").val(true)
  // If user clicks on “ignora”, simply proceed with the validation and ignore this warning
  bindGuestRelativesModalEvents(guestFormIdentifier) {
    console.log('binding relatives events...');
    const thisClass = this;
    $(this.relativesModalIdentifier)
      .on('shown.bs.modal', function (e) {
        thisClass.fixBootstrapBackdrop();
        const $this_modal = $(this);
        $this_modal.find('button.ignore').on('click', function (ev) {
          $this_modal.modal('hide');
          thisClass.ignoreRelatives = true;
          thisClass.submit();
        });
        $this_modal.find('button.proceed').on('click', function (ev) {
          $(thisClass.relativesInputIdentifier).val(true);
          $this_modal.modal('hide');
          thisClass.submit();
        });
      })
      .on('hide.bs.modal', function (e) {
        $(this).find('button.proceed').unbind();
        $(this).find('button.ignore').unbind();
        stopAnimation_for_guests(guestFormIdentifier);
      });
  }

  submit() {
    console.log('submitting...');
    if ((this.skipBedsValidation || this.isGuestRoomSet()) && this.isRelativesSet()) {
      $(this.formIdentifier).submit();
    }
    return false;
  }
}

const init = (
  _at_formIdentifier,
  _at_skipBedsValidation,
  _at_roomModalIdentifier,
  _at_requiredRoomInputIdentifiers,
  _at_relativesModalIdentifier,
  _at_relativesInputIdentifier,
  _guestFormIdentifier,
) => {
  try {
    return new GuestDataValidation(
      _at_formIdentifier,
      _at_skipBedsValidation,
      _at_roomModalIdentifier,
      _at_requiredRoomInputIdentifiers,
      _at_relativesModalIdentifier,
      _at_relativesInputIdentifier,
      _guestFormIdentifier,
    );
  } catch (e) {
    errorManager(e);
  }
};

window.GuestDataValidation = {
  init: init,
};
